// extracted by mini-css-extract-plugin
module.exports = {"list":"browse-BrowseVerticalElementList__list--2dQKC"};